import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import {
  HEADER_REQUEST_SUCCESS,
} from './constants'
import {storedb} from '../../views/client/storedb'
const keyDb = '_showOnline'

class Onlines extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onlineOpen: false,
      onlines: []
    };
  }

  toggle = () => {
    const newFlag = !this.state.onlineOpen
    this.setState({
      onlineOpen: newFlag
    }, () => {
      storedb().setValue(keyDb, newFlag)
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.header.type == HEADER_REQUEST_SUCCESS) {
      if (!nextProps.header.data) return
      this.setState({
        onlines: nextProps.header.data.onlines
      })
    }
  }
  render() {
    const {
      onlineOpen,
      onlines
    } = this.state

    const isOffline = (item) => {
      if (!item || !item.active_at) return false
      const activeAt = new Date(item.active_at)
      const currentDate = new Date()
      const differenceInTime = currentDate.getTime() - activeAt.getTime()
      const differenceInMutes = (differenceInTime / (1000 * 60))
      if (differenceInMutes < 5) {
        return false
      }
      return parseInt(differenceInMutes)
    }
    const classHidden = onlineOpen ? "" : "online-hidden"
    return (
      <div className={`animated fadeIn online ${classHidden}`}>
        {!onlineOpen && (
          <div className="online-header online-hidden-header" onClick={e => this.toggle()}>
            <div className="p-2">
              <div className="online-header-content online-header-content-small">
                <a title="Người đang online" className="fa fa-users fa-2x"></a>
              </div>
            </div>
          </div>
        )}
        {onlineOpen && (
          <Fragment>
            <div className="online-header" onClick={e => this.toggle()}>
              <div className="p-2">
                <div className="online-header-content">
                  <a title="Kích để ẩn">Online</a>
                  <i className="fa fa-arrow-circle-right fa-2x"></i>
                </div>
              </div>
            </div>
            <div className={"online-body"}>
              <ul className="nav">
                {onlines && onlines.map((item, index) => {
                  const offline = isOffline(item)
                  if (offline) {
                    return (
                      <li key={index} className="nav-item p-1">
                        <i className="nav-item-icon nav-item-icon-offline fa fa-user-circle-o"></i>
                        <a title={`${item.ten} / ${item.ma}`} className="nav-item-user nav-item-user-offline">{item.ten} <span className="minutes">{offline}m</span></a>
                      </li>
                    )
                  }
                  return (
                    <li key={index} className="nav-item p-1">
                      <i className="nav-item-icon fa fa-user-circle-o"></i>
                      <a className="nav-item-user">{item.ten}</a>
                    </li>
                  )
                })}
              </ul>
            </div>
          </Fragment>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  header: state.header,
})

const connected = connect(mapStateToProps)(Onlines)

const formed = reduxForm({
  form: 'onlines',
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/components/Header/Onlines.js